import { useMutation } from '@tanstack/react-query';
import { sendPasswordRecoveryCode } from '../requests';
import type { SendPasswordRecoveryCodeResponseDto } from '../types';

interface UsePasswordRecoveryConfirmationOptions {
  onSuccess?: (data: SendPasswordRecoveryCodeResponseDto) => void;
  onError?: (error: Error) => void;
}

export function usePasswordRecoveryConfirmation({
  onSuccess,
  onError,
}: UsePasswordRecoveryConfirmationOptions = {}) {
  const mutation = useMutation({
    mutationFn: sendPasswordRecoveryCode,
    onSuccess: data => {
      onSuccess?.(data);
    },
    onError: error => {
      console.error('Failed to send password recovery code:', error);
      onError?.(error);
    },
  });

  const sendRecoveryCode = (email: string) => {
    return mutation.mutateAsync({
      email,
    });
  };

  return {
    isSubmitting: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    sendRecoveryCode,
    reset: mutation.reset,
    mutation,
  };
}
